<!-- 关于我们 -->
<template>
  <div class="about">
    <v-head :bg="'#181818'"></v-head>
    <div class="container" style="min-width:1200px;">
      <!-- banner -->
      <div class="about-banner">
        <div class="about-banner-img">
          <div class="about-banner-bg" :style="'background-image:url(' + img + ')'"></div>
          <div class="about-banner-con">
            <div class="about-banner-title">全国性校园活动产品</div>
            <div class="about-banner-line">—</div>
            <div
              class="about-banner-message"
            >校园活动，是在校大学生课外时间的“主战场”，平均每个学校每天有10场校园活动在开展，以企业名义策划，开展全国性活动将作为企业进入校园市场的重要载体</div>
          </div>
        </div>
      </div>
      <!-- 平台介绍 -->
      <div class="about-intro">
        <div class="intro-layout">
          <div class="intro-title">
            <div class="intro-title-t">
              平台介绍
              <span class="intro-line"></span>
            </div>
            <div class="intro-title-b"></div>
          </div>
          <div class="intro-content">
            <p>“进校园”隶属于北京活联科技有限公司，是专注于为企业提供校园精准服务的信息化平台。</p>
            <p>“进校园”隶属于北京活联科技有限公司，是专注于为企业提供校园精准服务的信息化平台，是专注于为企业提供校园精准服务的信息化平台,是专注于为企业提供校园精准服务的信息化平台,是专注于为企业提供校园精准服务的信息化平台，是专注于为企业提供校园精准服务的信息化平台，是专注于为企业提供校园精准服务的信息化平台，是专注于为企业提供校园精准服务的信息化平台，是专注于为企业提供校园精准服务的信息化平台，是专注于为企业提供校园精准服务的信息化平台，是专注于为企业提供校园精准服务的信息化平台。</p>
            <p>我们的宗旨：为企业提供精准校园服务</p>
          </div>
        </div>
      </div>
      <!-- 我们的校园资源 -->
      <div class="about-resource">
        <div class="resource-layout">
          <div class="resource-title">
            <div class="resource-title-t">
              我们的校园资源
              <span class="resource-line"></span>
            </div>
            <div class="resource-title-b"></div>
          </div>
          <div class="resource-content">
            <div class="resource-data">
              <div class="resource-dataNum">{{ school_number }}+</div>
              <div class="resource-dataName">全国高校</div>
            </div>
            <div class="resource-data">
              <div class="resource-dataNum">{{ society_number }}+</div>
              <div class="resource-dataName">学校社团</div>
            </div>
            <div class="resource-data">
              <div class="resource-dataNum">{{ student_number }}+</div>
              <div class="resource-dataName">在校大学生资源</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 我们的宣传资源 -->
      <div class="about-propaganda">
        <div class="propaganda-layout">
          <div class="propaganda-title">
            <div class="propaganda-title-t">
              我们的宣传资源
              <span class="propaganda-line"></span>
            </div>
            <div class="propaganda-title-b"></div>
          </div>
          <div class="propaganda-content">
            <p>我们的宣传资源：</p>
            <p>自营App具有400万+大学生100万+日常，黄金位置用于企业品牌推广</p>
            <p>直管全国高校记者团，全国学生艺能团，每个团队有2000+优质大学生，植根全国400+高校</p>
            <p>管控1万+校园新媒体矩阵，宣传推广文稿快速直达学生“手上”</p>
          </div>
        </div>
      </div>
      <!-- 我们的服务流程 -->
      <div class="about-process">
        <div class="process-layout">
          <div class="process-title">
            <div class="process-title-t">
              我们的服务流程
              <span class="process-line"></span>
            </div>
            <div class="process-title-b"></div>
          </div>
          <div class="process-content">
            <div class="mibox">
              <div class="mibox-icon mibox-icon1"></div>
              <div class="mibox-name">接受咨询</div>
            </div>
            <div class="mibox">
              <div class="mibox-icon mibox-icon2"></div>
              <div class="mibox-name">详细了解需求</div>
            </div>
            <div class="mibox">
              <div class="mibox-icon mibox-icon3"></div>
              <div class="mibox-name">制定方案</div>
            </div>
            <div class="mibox">
              <div class="mibox-icon mibox-icon4"></div>
              <div class="mibox-name">签署协议</div>
            </div>
            <div class="mibox">
              <div class="mibox-icon mibox-icon5"></div>
              <div class="mibox-name">落地执行</div>
            </div>
            <div class="mibox">
              <div class="mibox-icon mibox-icon6"></div>
              <div class="mibox-name">结束验收</div>
            </div>
          </div>
        </div>
      </div>
      <!-- footer -->
    </div>
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import bg from '@/assets/img/bg-zz.png'
export default {
  data () {
    return {
      img: bg, // 临时图片
      school_number: '00',
      society_number: '00',
      student_number: '00',
      chinaDatas: []
    }
  },
  components: {
    'v-head': vHead,
    'v-footer': vFooter
  },
  created () {
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  mounted () {
    this.queryMap()
  },
  filters: {
    roundschool (val) {
      var newval = val.substring(0, val.length - 1)
      return Math.round(newval / 100) * 100
    }
  },
  methods: {
    // 我们的校园资源数据加载
    queryMap () {
      this.getNewCodeImgKey((uuid) => {
        this.$http({
          method: 'POST',
          url: '/common/province/data/info?' + uuid
        }).then(res => {
          if (res.code === 100) {
            for (let i = 0; i < res.result.labelList.length; i++) {
              const e = res.result.labelList[i]
              if (e.label === '学校数量') {
                let esch = e.value.substring(0, e.value.length - 1)
                this.school_number = Math.round(esch / 100) * 100
              } else if (e.label === '部落数量') {
                let esoc = e.value.substring(0, e.value.length - 1)
                this.society_number = Math.round(esoc / 10000) + 'w'
              } else if (e.label === '学生数量') {
                let estu = e.value.substring(0, e.value.length - 1)
                this.student_number = Math.round(estu / 10000) + 'w'
              }
            }
          } else {
            this.$message.error('请求有误')
            return false
          }
        }).catch(error => {
          console.log(error)
          return false
        })
      })
    },
    // 生成UUID
    getNewCodeImgKey (callback) {
      let randomKey = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0
        let v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
      callback(randomKey)
    }
  }
}
</script>
<style lang="scss" scoped>
.about {
  width: 100%;
  height: 100%;
  overflow: hidden;

  // banner
  .about-banner {
    width: 100%;
    height: 450px;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;

    .about-banner-img {
      width: 100%;
      height: 100%;
      overflow: hidden;

      .about-banner-bg {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      }

      .about-banner-con {
        width: 100%;
        height: 100%;
        padding-left: 17.5%;
        padding-right: 40%;
        padding-top: 120px;
        padding-bottom: 20px;
        box-sizing: border-box;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: flex-start;

        .about-banner-title {
          font-size: 36px;
          color: #ffffff;
          padding: 12px 0;
        }

        .about-banner-line {
          font-size: 24px;
          font-weight: 700;
          color: #ffffff;
          padding: 8px 0;
        }

        .about-banner-message {
          font-size: 16px;
          font-weight: 400;
          color: #ffffff;
          line-height: 26px;
          padding: 12px 0;
          letter-spacing: 1px;
        }

        .about-banner-more {
          padding-top: 18px;

          button {
            background-color: transparent;
            color: #ffffff;
            font-size: 14px;
            border-radius: 2px;
            padding: 9px 32px;
            position: relative;
            -webkit-transition-duration: 0.4s;
            /* Safari */
            transition-duration: 0.4s;

            i {
              position: absolute;
            }
          }

          button:hover {
            background-color: #ffffff;
            color: #0e0c12;
          }
        }
      }
    }
  }

  // 平台介绍
  .about-intro {
    width: 100%;
    padding: 25px 0;
    .intro-layout {
      width: 1200px;
      margin: 0 auto;
      .intro-title {
        position: relative;
        height: 160px;
        text-align: center;
        box-sizing: border-box;
        margin-bottom: 20px;
        .intro-title-t {
          height: 100%;
          width: 220px;
          line-height: 140px;
          font-size: 18px;
          font-weight: 700;
          position: absolute;
          left: 50%;
          top: 0;
          margin-left: -110px;
          z-index: 2;
          color: #333333;
          text-shadow: 2px 2px 1px #999999;
          .intro-line {
            width: 26px;
            height: 4px;
            background-color: #1ca2fe;
            position: absolute;
            bottom: 45px;
            left: 50%;
            margin-left: -13px;
            z-index: 2;
          }
        }
        .intro-title-b {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          z-index: 1;
          background-image: url("../../assets/img/icon-process/01.png");
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
      .intro-content {
        padding: 40px 10px;
        box-sizing: border-box;
        text-align: left;
        p {
          font-size: 14px;
          line-height: 22px;
          padding: 12px 0;
          color: #333333;
        }
      }
    }
  }
  // 我们的校园资源
  .about-resource {
    width: 100%;
    padding: 40px 0;
    background-color: #f2f2f2;
    .resource-layout {
      width: 1200px;
      margin: 0 auto;
      .resource-title {
        position: relative;
        height: 160px;
        text-align: center;
        box-sizing: border-box;
        margin-bottom: 20px;
        .resource-title-t {
          height: 100%;
          width: 220px;
          line-height: 140px;
          font-size: 18px;
          font-weight: 700;
          position: absolute;
          left: 50%;
          top: 0;
          margin-left: -110px;
          z-index: 2;
          color: #333333;
          text-shadow: 2px 2px 1px #999999;
          .resource-line {
            width: 26px;
            height: 4px;
            background-color: #1ca2fe;
            position: absolute;
            bottom: 45px;
            left: 50%;
            margin-left: -13px;
            z-index: 2;
          }
        }
        .resource-title-b {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          z-index: 1;
          background-image: url("../../assets/img/icon-process/02.png");
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
      .resource-content {
        padding: 40px 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .resource-data {
          flex: 1;
          border-right: 2px solid #eaeaea;
          .resource-dataNum {
            font-size: 56px;
            font-weight: 700;
            text-align: center;
            padding: 8px 0;
            color: #000000;
          }
          .resource-dataName {
            font-size: 16px;
            font-weight: 700;
            text-align: center;
            padding: 8px 0;
          }
        }
        .resource-data:last-child {
          border-right: 0;
        }
      }
    }
  }
  // 我们的宣传资源
  .about-propaganda {
    width: 100%;
    padding: 25px 0;
    .propaganda-layout {
      width: 1200px;
      margin: 0 auto;
      .propaganda-title {
        position: relative;
        height: 160px;
        text-align: center;
        box-sizing: border-box;
        margin-bottom: 20px;
        .propaganda-title-t {
          height: 100%;
          width: 220px;
          line-height: 140px;
          font-size: 18px;
          font-weight: 700;
          position: absolute;
          left: 50%;
          top: 0;
          margin-left: -110px;
          z-index: 2;
          color: #333333;
          text-shadow: 2px 2px 1px #999999;
          .propaganda-line {
            width: 26px;
            height: 4px;
            background-color: #1ca2fe;
            position: absolute;
            bottom: 45px;
            left: 50%;
            margin-left: -13px;
            z-index: 2;
          }
        }
        .propaganda-title-b {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          z-index: 1;
          background-image: url("../../assets/img/icon-process/03.png");
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
      .propaganda-content {
        padding: 40px 10px;
        box-sizing: border-box;
        text-align: center;
        p {
          font-size: 14px;
          line-height: 22px;
          color: #333333;
        }
      }
    }
  }
  // 我们的服务流程
  .about-process {
    width: 100%;
    padding: 40px 0;
    background-color: #f2f2f2;
    .process-layout {
      width: 1500px;
      margin: 0 auto;
      .process-title {
        position: relative;
        height: 160px;
        text-align: center;
        box-sizing: border-box;
        margin-bottom: 20px;
        .process-title-t {
          height: 100%;
          width: 220px;
          line-height: 140px;
          font-size: 18px;
          font-weight: 700;
          position: absolute;
          left: 50%;
          top: 0;
          margin-left: -110px;
          z-index: 2;
          color: #333333;
          text-shadow: 2px 2px 1px #999999;
          .process-line {
            width: 26px;
            height: 4px;
            background-color: #1ca2fe;
            position: absolute;
            bottom: 45px;
            left: 50%;
            margin-left: -13px;
            z-index: 2;
          }
        }
        .process-title-b {
          height: 100%;
          width: 100%;
          position: absolute;
          top: 0;
          z-index: 1;
          background-image: url("../../assets/img/icon-process/04.png");
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
      .process-content {
        padding: 40px 10px;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        grid-column-gap: 60px;
        .mibox {
          height: 160px;
          border: 1px dashed #cccccc;
          display: flex;
          flex-direction: column;
          color: #666666;
          cursor: pointer;
          .mibox-icon {
            flex-grow: 1;
            background-repeat: no-repeat;
            background-size: auto 55%;
            background-position: center bottom;
          }
          .mibox-name {
            height: 80px;
            line-height: 80px;
            font-size: 20px;
            text-align: center;
            text-shadow: 0 0 1px #666666;
          }
          .mibox-icon1 {
            background-image: url("../../assets/img/icon-process/icon-pro1.png");
          }
          .mibox-icon2 {
            background-image: url("../../assets/img/icon-process/icon-pro5.png");
          }
          .mibox-icon3 {
            background-image: url("../../assets/img/icon-process/icon-pro6.png");
          }
          .mibox-icon4 {
            background-image: url("../../assets/img/icon-process/icon-pro4.png");
          }
          .mibox-icon5 {
            background-image: url("../../assets/img/icon-process/icon-pro3.png");
          }
          .mibox-icon6 {
            background-image: url("../../assets/img/icon-process/icon-pro2.png");
          }
        }
        .mibox:hover {
          opacity: 0.7;
        }
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .about {
    .about-process {
      .process-layout {
        width: 1200px;
        .process-content {
          .mibox {
            height: 130px;
            .mibox-name {
              height: 60px;
              line-height: 60px;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about/about.vue